import React from "react";
import { Link } from "react-router-dom";
import "./PlanCard.css";

const MS_IN_DAY = 1000 * 60 * 60 * 24;

const PlanCard = ({ plan }) => {
  const { _id, name, durationInYears, postsCount, createdAt } = plan;

  const totalDays = durationInYears * 365;
  const daysPassed = Math.floor(
    (Date.now() - new Date(createdAt)) / MS_IN_DAY
  );
  const daysLeft = Math.max(totalDays - daysPassed, 0);
  const progress = Math.min((daysPassed / totalDays) * 100, 100);

  const theme =
    durationInYears === 1
      ? "theme-1y"
      : durationInYears === 3
      ? "theme-3y"
      : "theme-5y";

  const formatDate = (date) =>
    new Date(date).toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });

  return (
    <Link to={`/dashboard/year-plan/${_id}`} className={`plan-card ${theme}`}>
      <div className="plan-header">
        {durationInYears === 5 && (
          <span className="plan-p5-badge">PROJECT-5</span>
        )}
        <h3>{name}</h3>
        <span className="plan-duration-tag">{durationInYears} Year Vision</span>
      </div>

      <p className="plan-started">
        Started on <strong>{formatDate(createdAt)}</strong>
      </p>

      <div className="plan-meta">
        <span>{postsCount} nodes</span>
        <span>{daysLeft} days left</span>
      </div>

      <div className="progress-track">
        <div
          className="progress-fill"
          style={{ width: `${progress}%` }}
        />
      </div>
    </Link>
  );
};

export default PlanCard;
